import { Button, Stack, Typography } from '@mui/material';
import { DefinitionGrid, SectionCard, StatusBadge } from '../../../design-system';

export type PeopleRegistrationOutcomeProps = {
  message: string;
  name: string;
  hireDate: string;
  organization?: string;
  workerNumber?: string;
  onOpenRequest?: () => void;
  onClose: () => void;
};

/** 제출한 내용과 다음 행동만 안내합니다. 승인·계정·온보딩 상태를 추정하지 않습니다. */
export function PeopleRegistrationOutcome({
  message, name, hireDate, organization, workerNumber, onOpenRequest, onClose,
}: PeopleRegistrationOutcomeProps) {
  return <SectionCard title="입사 승인 요청 완료" bodyPadding="standard"
    action={<StatusBadge label="승인 요청 제출됨" tone="success" />}>
    <Stack spacing={2}>
      <Typography role="status" variant="body2">{message}</Typography>
      <DefinitionGrid columns={4} items={[
        { label: '구성원', value: name },
        { label: '요청 입사일', value: hireDate },
        { label: '배정 요청 조직', value: organization || '미지정' },
        { label: '요청 사번', value: workerNumber || '사번 발급 정책에 따라 처리' },
      ]} />
      <Stack spacing={0.5}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>다음 할 일</Typography>
        <Typography variant="body2" color="text.secondary">
          {onOpenRequest ? '승인 요청 상세에서 진행 상황을 확인해 주세요. ' : '승인 요청의 진행 상황은 조회 권한이 있는 담당자에게 확인해 주세요. '}
          입사가 반영되면 구성원 상세에서 온보딩을 시작할 수 있습니다. 온보딩 관리 권한이 필요합니다.
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
        {onOpenRequest && <Button variant="outlined" onClick={onOpenRequest}>승인 요청 확인</Button>}
        <Button color="inherit" onClick={onClose}>닫기</Button>
      </Stack>
    </Stack>
  </SectionCard>;
}
